<template>
  <v-card-text v-show="show">
    <v-row>
      <v-col>
        <v-text-field autofocus label="Non-geographic number" v-model="nonGeoNumber" :disabled="addNumberLoading" dense outlined :hide-details="nonGeoNumberErrors.length===0" :error-messages="nonGeoNumberErrors" @input="$v.nonGeoNumber.$touch()" @blur="$v.nonGeoNumber.$touch()" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-select label="Translate to" v-model="translateTo" :items="createTranslateToItems()" :disabled="addNumberLoading" dense outlined :hide-details="translateToErrors.length===0" :error-messages="translateToErrors" @input="$v.translateTo.$touch()" @blur="$v.translateTo.$touch()"></v-select>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, minLength, maxLength, numeric } from 'vuelidate/lib/validators';

const startWith033 = val => {
  return /^(033)/.test(val);
};

export default {
  props: { currentTabType:String, addNumberLoading:Boolean, updateMaxWidth:Function, updateNumbersToSend:Function, displayResetBtn:Function },
  validations: {
    nonGeoNumber: { required, numeric, startWith033, minLength: minLength(11), maxLength: maxLength(11) },
    translateTo: { required }
  },
  data() {
    return {
      show: false,
      nonGeoNumber: '',
      translateTo: null,
    };
  },
  computed: {
    ...mapGetters('products', ['getAllProductNumbers']),
    nonGeoNumberErrors() {
      const errors = [];
      if (!this.$v.nonGeoNumber.$dirty) return errors;
      !this.$v.nonGeoNumber.required && errors.push('Non-geographic number is a required field');
      !this.$v.nonGeoNumber.numeric && errors.push('Non-geographic number must be numeric');
      !this.$v.nonGeoNumber.startWith033 && errors.push('Non-geographic number should start with 033');
      (!this.$v.nonGeoNumber.minLength || !this.$v.nonGeoNumber.maxLength) && errors.push('Non-geographic number should be 11 digits long');
      return errors;
    },
    translateToErrors() {
      const errors = [];
      if (!this.$v.translateTo.$dirty) return errors;
      !this.$v.translateTo.required && errors.push('Translate to is a required field');
      return errors;
    },
  },
  mounted() {
    this.$root.$on('ADD_NUMBERS_DIALOG_NON_GEO_RESET', this.resetForm);
    this.$root.$on('ADD_NUMBERS_DIALOG_NON_GEO_RESET_VALIDATION', this.$v.$reset);
    this.onCurrentTabTypeChange(this.currentTabType);
  },
  watch: {
    currentTabType(val) {
      this.onCurrentTabTypeChange(val);
    },
    nonGeoNumber() {
      this.updateParentByForm();
    },
    translateTo() {
      this.updateParentByForm();
    }
  },
  methods: {
    onCurrentTabTypeChange(val) {
      let isCurrentTabTypeMatched = val === 'nonGeo';
      if (isCurrentTabTypeMatched) {
        this.updateMaxWidth(350);
        this.updateParentByForm();
      }
      this.show = isCurrentTabTypeMatched;
    },
    createTranslateToItems() {
      return this.getAllProductNumbers.reduce((acc, item) => {
        let number = item.number;
        if (number && item.non_geographic === false) {
          acc.push(number);
        }
        return acc;
      }, []);
    },
    resetForm() {
      this.nonGeoNumber = '';
      this.translateTo = null;
      this.$v.$reset();
    },
    updateParentByForm() {
      this.displayResetBtn(this.$v.nonGeoNumber.required || this.$v.translateTo.required);
      this._updateNumbersToSend();
    },
    _updateNumbersToSend() {
      let numbersToSend = [];
      if (!this.$v.$invalid) {
        let translateTo = this.getAllProductNumbers.find(item => item.number == this.translateTo);
        numbersToSend.push({
          number: this.nonGeoNumber,
          non_geographic: true,
          translate_to_number_id: translateTo.id
        });
      }
      this.updateNumbersToSend(numbersToSend);
    },
  },
}
</script>
